import { inject, Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { injectReportsHttpApiService } from '@core/reports-contracts';
import type { ReportResultsDataParams, ReportResults } from '@core/reports-types';
import { getTextContentFromHTML } from '@core/utils-legacy';

import { SharedAnalyticsReportsHttpApiService } from '../../services/reports-http-api.service';

@Injectable()
export class ReportsResultsHttpClient {
  private readonly sanitizer = inject(DomSanitizer);
  private readonly httpApi = injectReportsHttpApiService();

  public load(kind: string, params: ReportResultsDataParams): Observable<ReportResults> {
    return this.httpApi
      .get(this.isSharedAnalytics() ? '/results' : `/${kind}`, {
        ...params,
        format: 'results',
        translate: true,
      })
      .pipe(
        map((data: ReportResults) => ({
          checksum: data.checksum,
          meta: data.meta,
          results: {
            columns: data.results.columns.map(col => ({
              name: getTextContentFromHTML(
                this.sanitizer.sanitize(SecurityContext.HTML, col.name)!,
              ),
              id: `${col.id}`,
            })),
            rows: data.results.rows.map(row => ({
              ...row,
              name: getTextContentFromHTML(
                this.sanitizer.sanitize(SecurityContext.HTML, row.name)!,
              ),
              id: `${row.id || row.name}`, // TODO: remove when ensured that `row.id` is always included in response
              values: row.values,
            })),
          },
        })),
      );
  }

  // TODO shared-analytics remove when migrated fully to shared analytics reports http api service
  private isSharedAnalytics(): boolean {
    return this.httpApi instanceof SharedAnalyticsReportsHttpApiService;
  }
}
